<template>
  <div>
    <highcharts ref="chart" :options="options" />
    <br />
    <b-table
      :striped="true"
      :narrowed="true"
      :hoverable="true"
      :data="values"
      :columns="columns"
    />
  </div>
</template>

<script>
import Commute from '@/models/carbon/Commute.js'
import '@/plugins/highcharts.js'

export default {
  name: 'CommutesVolumesBar',
  props: {
    ghgi: {
      type: Object,
      default: null
    }
  },
  computed: {
    values: function () {
      let values = []
      let volumes = this.ghgi.emissions.commutes.status.volumePerMode
      for (let position of Object.keys(volumes)) {
        let allModes = {}
        let i = 0
        for (let cat of Commute.TRAVELS_MODES) {
          allModes[cat] = this.$options.filters.splitNumber(
            volumes[position][i]
          )
          i += 1
        }
        allModes['position'] = '<nobr>' + this.$t(position) + '</nobr>'
        values.push(allModes)
      }
      return values
    },
    columns: function () {
      let columns = [
        {
          field: 'position',
          label: this.$t('position'),
          sticky: true
        }
      ]
      for (let mode of Commute.TRAVELS_MODES) {
        columns.push({
          field: mode,
          label: this.$t(mode),
          numeric: true
        })
      }
      return columns
    },
    series: function () {
      let volumePerMode = this.ghgi.emissions.commutes.status.volumePerMode
      let sz = []
      for (let position of Object.keys(volumePerMode)) {
        sz.push({
          name: this.$t(position + '.short'),
          data: volumePerMode[position]
        })
      }
      return sz
    },
    options: function () {
      return {
        chart: {
          type: 'column'
        },
        title: {
          text: ''
        },
        series: this.series,
        xAxis: {
          categories: Commute.TRAVELS_MODES.map((val) => this.$t(val)),
          crosshair: true
        },
        yAxis: {
          min: 0,
          title: {
            text: this.$t('person.day')
          }
        },
        tooltip: {
          shared: true,
          valueDecimals: 2,
          valueSuffix: ' ' + this.$t('person.day')
        }
      }
    }
  }
}
</script>
